import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'
import { ajaxPost } from '../ajax'

function StripeM2Modal({connected, currency, amount, appFee, location, onClose, onPayment}) {
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (connected) initPayment()
  }, [])

  const fetchPaymentIntent = async () => {
    setLoading(true)
    const params = {
      currency: currency,
      amount: amount.toFixed(2),
      app_fee: appFee.toFixed(2),
      location_id: location,
      terminal: true
    }
    const response = await ajaxPost('/admins/payment/create_intent', params)
    const json = await response.json()
    setLoading(false)
    return json.intent 
  }

  const initPayment = async () => {
    const intent = await fetchPaymentIntent()
    if (intent.error) return setError(intent.error)

    onPayment(intent.secret)
    onClose()
  }

  return (
    <ReactModal isOpen={true} onRequestClose={onClose}>
      <div className='stripe-reader-payment'>
        { error && <label className='stripe-error'>{error}</label> }
        { loading && <div className='animated-spinner'></div> }
        { !connected && <h3>No M2 reader connected</h3> }
      </div>
    </ReactModal>
  )
}

StripeM2Modal.propTypes = {
  connected: PropTypes.bool,
  amount: PropTypes.number.isRequired,
  appFee: PropTypes.number.isRequired,
  location: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onPayment: PropTypes.func.isRequired,
}

export default StripeM2Modal

